var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.725H8.828A8.829 8.829 0 0 1 0 414.897V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828v317.793a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#f5f5f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff4b55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 123.591h512v35.31H0zM0 353.101h512v35.31H0zM248.503 228.834l12.427 16.256 19.403-6.495c1.085-.363 2.008.864 1.358 1.805l-11.62 16.842 12.173 16.447c.681.919-.201 2.176-1.298 1.849l-19.608-5.847-11.88 16.66c-.664.931-2.132.481-2.159-.662l-.498-20.456-19.516-6.151c-1.091-.344-1.117-1.879-.038-2.259l19.3-6.795-.181-20.461c-.01-1.143 1.442-1.642 2.137-.733zM184.489 319.597c-35.095 0-63.564-28.469-63.564-63.596 0-35.062 28.469-63.595 63.564-63.595 13.057 0 25.099 4.015 35.134 10.813 1.537 1.041 3.29-.979 2.004-2.316-14.997-15.593-36.224-25.105-59.758-24.301-40.434 1.379-73.906 33.798-76.49 74.172-2.959 46.244 33.658 84.676 79.25 84.676 22.457 0 42.641-9.389 57.054-24.401 1.273-1.326-.484-3.315-2.006-2.283-10.047 6.81-22.108 10.831-35.188 10.831z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCy);
export default __webpack_public_path__ + "static/media/cy.ed76e1b2f4df293fd88c84c45b249974.svg";
export { ForwardRef as ReactComponent };